<template>
  <div class="vertical-menu" :class="{ 'big-top': bigTop }">
    <div class="vertical-menu-top">
      <icon-base iconColor="#fff" viewBox="0 0 32 32">
        <icon-my-wires />
      </icon-base>
    </div>
    <div class="vertical-menu-bottom fixed-menu">
      <router-link tag="li" :to="{ name: 'home' }">
        <icon-base :icon-name="$t('web_icon_tooltip_home_page')"><icon-wires /></icon-base>
      </router-link>
      <router-link tag="li" :to="{ name: 'specification' }">
        <icon-base :icon-name="$t('web_icon_tooltip_specification_page')"><icon-specification /></icon-base>
      </router-link>
      <router-link tag="li" :to="{ name: 'schedule' }">
        <icon-base :icon-name="$t('web_icon_tooltip_schedule_page')"><icon-schedule /></icon-base>
      </router-link>
      <router-link tag="li" :to="{ name: 'recommendations' }">
        <icon-base :icon-name="$t('web_icon_tooltip_recommendations_page')">
          <icon-recommendations />
        </icon-base>
      </router-link>
      <router-link tag="li" :to="{ name: 'logData' }">
        <icon-base :icon-name="$t('web_icon_tooltip_log_page')"><icon-log /></icon-base>
      </router-link>
    </div>
    <div class="extended-menu">
      <div class="vertical-menu-top"></div>
      <div class="vertical-menu-bottom">
        <router-link tag="li" :to="{ name: 'home' }">
          <a>{{ $t('dashboard_units') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'specification' }">
          <a>{{ $t('tab_title_specification') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'schedule' }">
          <a>{{ $t('tab_title_schedule') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'recommendations' }">
          <a>{{ $t('tab_title_benchmarks') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'logData' }">
          <a>{{ $t('log_title') }}</a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase';
import IconLog from '@/components/icons/IconLog';
import IconRecommendations from '@/components/icons/IconRecommendations';
import IconSchedule from '@/components/icons/IconSchedule';
import IconWires from '@/components/icons/IconWires';
import IconMyWires from '@/components/icons/IconMyWires';
import IconSpecification from '@/components/icons/IconSpecification';

export default {
  components: {
    IconBase,
    IconLog,
    IconRecommendations,
    IconSchedule,
    IconWires,
    IconMyWires,
    IconSpecification
  },
  props: {
    bigTop: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    drawer: true,
    mini: true,
    right: null
  }),
  methods: {
    goToLandingPage() {
      this.$router.push({ name: 'landing' });
    }
  }
};
</script>

<style lang="scss">
.vertical-menu {
  width: 70px;
  height: 100%;
  z-index: 10;
  &-top {
    background: linear-gradient(360deg, #0a2b5a 0%, #154281 100%);
    border-bottom-left-radius: 35px;
    height: 200px;
    svg {
      position: relative;
      top: 20px;
      left: 10px;
    }
  }
  &-bottom {
    margin-top: 50px;
    li {
      list-style-type: none;
      padding: 0 5px 0 15px;
      height: 25px;
      margin: 35px 0;
      color: #9b9b9b;
      a {
        cursor: pointer;
        color: #9b9b9b;
        text-decoration: none;
      }
      &.router-link-active {
        color: var(--v-primary-base);
        font-weight: bold;
        position: relative;
        // border-right: 4px solid var(--v-primary-base);
        &:after {
          content: '';
          border-bottom: 3px solid var(--v-primary-base);
          border-left: 2px solid transparent;
          border-right: 2px solid transparent;
          height: 0;
          width: 30px;
          position: absolute;
          right: -10px;
          top: 10px;
          transform: rotate(-90deg);
        }
        a {
          color: var(--v-primary-base);
          text-decoration: none;
        }
      }
    }

    &.fixed-menu {
      li {
        cursor: pointer;
      }
      &.router-link-active {
        svg {
          color: var(--v-primary-base);
        }
      }
    }
  }
  &.big-top {
    .vertical-menu-top {
      height: 290px;
    }
  }
  .extended-menu {
    overflow: hidden;
    position: absolute;
    visibility: hidden;
    opacity: 0;
    width: 0;
    top: 0;
    left: 50px;
    height: 100%;
    transition: width 0.3s, visibility 0s, opacity 0.3s linear;
    background-color: #fff;
    .vertical-menu-top {
      border-bottom-left-radius: 0;
    }
    .vertical-menu-bottom {
      padding: 0 15px 0 0;
    }
  }
  &:hover {
    position: relative;
    .extended-menu {
      z-index: 11;
      position: absolute;
      top: 0;
      left: 50px;
      width: 250px;
      visibility: visible;
      opacity: 1;
      transition: width 0.3s, visibility 0s, opacity 0.3s linear;
      box-shadow: 24px 0 35px -30px rgba(21, 66, 129, 0.54);
    }

    .vertical-menu-bottom.fixed-menu {
      li {
        &.router-link-active {
          border-right: 0;
        }
      }
    }
  }
}
</style>
